import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { useSelector, useDispatch } from 'react-redux';
import { capitalize } from '@material-ui/core';
import { getPricingAndCoverage } from 'utils/utils';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: 10,
        textAlign: 'center',
        color: '#ffffff'
    },
    sectionTitle: {
        padding: 10,
        borderRadius: 0,
        textAlign: 'center',
        color: '#ffffff',
        fontWeight: 700,
        letterSpacing: 1,
        fontSize: 14
    },
    rowRoot: {
        '& .MuiTableCell-root': {
            padding: 10
        }
    }
}));

function Premiums(props) {
    const { quoteDataTable, color } = props;
    const classes = useStyles();
    const dispatch = useDispatch();
    const states = useSelector(state => {
        return state.globalStates
    })

    const renderRows = () => {
        const pricingAndCoverage = getPricingAndCoverage(quoteDataTable).premiumsData;
        const result = Object.keys(pricingAndCoverage).map(( item, index ) => {
            let title = item;
            
            if(title === 'Riot_Strike') {
                title = title.replace(/_/g, ',');
            }

            const price = pricingAndCoverage[item].price;
           
            return(
                <TableRow key={ `coverage-row-${ index }`} className={ classes.rowRoot }>
                    <TableCell component="td" scope="row">{ `${ capitalize(title.replace(/_/g, ' ')) }` }</TableCell>
                    <TableCell component="td" scope="row" align={ 'right' }>{ price }</TableCell>
                </TableRow>
            )
        })
        return result;
    }
    return(
        <Fragment>
            <Paper elevation={0} style={{ background: color }} className={ classes.sectionTitle }>Premium</Paper>
            <TableContainer component={Paper}>
                <Table aria-label="coverage-table">
                    <TableBody>
                        { renderRows() }
                    </TableBody>
                </Table>
            </TableContainer>
        </Fragment>
    )
}

export default Premiums;